import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["close", "countdown"]

  static values = {
    startedAt: String,
    endedAt: String,
    ctaUrl: String,
    id: Number
  }

  private countdownInterval: number | undefined

  connect() {
    const closedAnnouncements = JSON.parse(sessionStorage.getItem('closedAnnouncements') || '[]')
    if (!closedAnnouncements.includes(this.idValue)) {
      this.element.classList.remove('hidden')
    }
    if (this.hasCountdownTarget) {
      this.startCountdown()
    }
  }
  
  disconnect() {
    if (this.countdownInterval) {
      window.clearInterval(this.countdownInterval)
    }
  }

  private startCountdown() {
    const endTime = new Date(this.endedAtValue).getTime()
    
    this.countdownInterval = window.setInterval(() => {
      const now = new Date().getTime()
      const distance = endTime - now

      if (distance < 0) {
        window.clearInterval(this.countdownInterval)
        this.countdownTarget.innerHTML = "Abgelaufen!"
        this.element.classList.add('hidden')
        return
      }

      const weeks = Math.floor(distance / (1000 * 60 * 60 * 24 * 7))
      const days = Math.floor((distance % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      let countdownText = ""
      if (weeks > 0) countdownText += `${weeks}W `
      if (days > 0) countdownText += `${days}T `
      countdownText += `${hours}Std ${minutes}Min ${seconds}Sek`

      this.countdownTarget.innerHTML = countdownText
    }, 1000)
  }
  
  close(e) {
    e.preventDefault()
    
    const closedAnnouncements = JSON.parse(sessionStorage.getItem('closedAnnouncements') || '[]')
    
    if (!closedAnnouncements.includes(this.idValue)) {
      closedAnnouncements.push(this.idValue)
      sessionStorage.setItem('closedAnnouncements', JSON.stringify(closedAnnouncements))
    }
    
    this.element.classList.add('hidden')
  }

  click(e) {
    if (e.target.closest('[data-announcements-target="close"]')) {
      return
    }

    if (this.ctaUrlValue) {
      window.open(this.ctaUrlValue, '_blank')
    }
  }
}
